import { Consumer, PartnerInfo } from 'entities/Consumer';
import { ConsumerCar } from 'entities/ConsumerCar';
import { MpiPerformedStatus } from 'entities/MpiPerformedStatus';
import { handleActions } from 'redux-actions';
import {
  clearRepairRequest,
  getConsumer,
  getConsumerCar,
  getMpiPerformedStatus,
  getSuggestedRepairs,
  getRepairRequest,
  getRepairRequestCar,
  updateCarLastOilChange,
  getRepairRequestDiagnosis,
  getFleet,
  getPartnerInfo,
  getResponsiblePartyTypes,
  setAllAvailableResponsibleParties,
} from 'store/repairRequest/actions';
import { createSimpleHandler } from 'store/utils/createSimpleHandler';
import { RepairRequest } from 'entities/RepairRequest';

export interface IRepairRequestStoreState {
  repairRequest?: RepairRequest;
  car?: any;
  consumer?: Consumer;
  consumerCar?: ConsumerCar;
  mpiPerformedStatus?: MpiPerformedStatus;
  suggestedRepairs?: any[];
  requestDiagnosis?: any;
  fleet: any;
  partnerInfo?: PartnerInfo;
  responsiblePartyTypes?: any[];
  allAvailableResponsibleParties?: any[];
  consumerContactInfo: any;
}

const defaultState: any = {
  repairRequest: undefined,
  car: undefined,
  consumer: undefined,
  consumerCar: undefined,
  mpiPerformedStatus: undefined,
  suggestedRepairs: undefined,
  fleet: undefined,
  partnerInfo: undefined,
  responsiblePartyTypes: undefined,
};

const reducer = handleActions(
  {
    [getRepairRequest.typeAPISuccess]: createSimpleHandler('repairRequest'),
    [getRepairRequestCar.typeAPISuccess]: createSimpleHandler('car'),
    [getConsumer.typeAPISuccess]: createSimpleHandler('consumer'),
    [getFleet.typeAPISuccess]: createSimpleHandler('fleet'),
    [updateCarLastOilChange.typeAPISuccess]: createSimpleHandler('consumerCar'),
    [getConsumerCar.typeAPISuccess]: createSimpleHandler('consumerCar'),
    [getPartnerInfo.typeAPISuccess]: createSimpleHandler('partnerInfo'),
    [getRepairRequestDiagnosis.typeAPISuccess]:
      createSimpleHandler('requestDiagnosis'),
    [getMpiPerformedStatus.typeAPISuccess]:
      createSimpleHandler('mpiPerformedStatus'),
    [getSuggestedRepairs.typeAPISuccess]: (state, action) => {
      const rawResponse = action.payload;
      let recommendedById: any = null;

      [
        'addedRepairs',
        'recommendedRepairs',
        'rejectedRepairs',
        'createdRepairs',
        'scheduledRepairs',
      ].forEach((key) => {
        (rawResponse[key] || []).forEach((recommended: any) => {
          recommendedById = {
            ...recommendedById,
            [recommended.id]: {
              ...recommended,
              suggestedStatus: key.replace(/repairs/gi, ''),
            },
          };
        });
      });
      return {
        ...state,
        suggestedRepairs: recommendedById,
      };
    },
    [getResponsiblePartyTypes.typeAPISuccess]: createSimpleHandler(
      'responsiblePartyTypes'
    ),
    [setAllAvailableResponsibleParties.type]: createSimpleHandler(
      'allAvailableResponsibleParties'
    ),
    [clearRepairRequest.type]: (state) => ({
      ...state,
      repairRequest: null,
    }),
  },
  defaultState
);

export default reducer;
